<template>
  <div class="readiness-strip d-flex flex-wrap">
    <b-badge
      v-for="flag in flags"
      :key="flag.key"
      :variant="flag.value.ok ? 'success' : 'light-danger'"
      class="readiness-pill mr-2 mb-1 font-weight-bold"
      v-b-tooltip.hover
      :title="tooltipFor(flag)"
    >
      <i
        class="fa readiness-icon mr-1"
        :class="flag.value.ok ? 'fa-check' : 'fa-times'"
      ></i>
      {{ flag.short }}
    </b-badge>
  </div>
</template>

<script>
// The six billing readiness flags, in the fixed strip order.
const FLAG_ORDER = [
  { key: "insightClient", short: "Billing client" },
  { key: "subagent", short: "Broker" },
  { key: "policy", short: "Policy" },
  { key: "priced", short: "Priced" },
  { key: "posted", short: "Posted" },
  { key: "stampedBack", short: "CRM updated" }
];

export default {
  name: "ReadinessStrip",

  props: {
    readiness: {
      type: Object,
      required: true
    }
  },

  computed: {
    flags: function() {
      return FLAG_ORDER.map(f => ({
        key: f.key,
        short: f.short,
        value: this.readiness[f.key] || { ok: false }
      }));
    }
  },

  methods: {
    tooltipFor: function(flag) {
      const state = flag.value.ok ? "OK" : "Not ready";
      return flag.value.detail ? `${flag.short}: ${state} — ${flag.value.detail}` : `${flag.short}: ${state}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.readiness-pill {
  font-size: 0.8rem;
  cursor: default;
}

.readiness-icon {
  font-size: 0.7rem;
}
</style>
